export default {
    name: 'CiCatalogHome'
};
